import differenceInCalendarDays from "date-fns/differenceInCalendarDays";
import differenceInHours from "date-fns/differenceInHours";
import differenceInMinutes from "date-fns/differenceInMinutes";
import differenceInSeconds from "date-fns/differenceInSeconds";
import differenceInMonths from "date-fns/differenceInMonths";
import differenceInYears from "date-fns/differenceInYears";

const formatSpan = (
  singular: "year" | "month" | "day" | "hour" | "minute" | "second",
  count: number
) => {
  if (count > 1) return `${singular}s`;

  return singular;
};
export const calculateTimePast = (
  dateToCompare: Date,
  nowOverride?: Date
): string => {
  const now = nowOverride ? nowOverride : new Date();

  const diffInYears = differenceInYears(now, dateToCompare);
  if (diffInYears >= 1) {
    return `Over ${diffInYears} ${formatSpan("year", diffInYears)} ago`;
  }

  const diffInMonths = differenceInMonths(now, dateToCompare);
  if (diffInMonths >= 1) {
    return `${diffInMonths} ${formatSpan("month", diffInMonths)} ago`;
  }

  const diffInDays = differenceInCalendarDays(now, dateToCompare);
  if (diffInDays >= 1 && diffInDays < 90) {
    return `${diffInDays} ${formatSpan("day", diffInDays)} ago`;
  }

  const diffInHours = differenceInHours(now, dateToCompare);
  if (diffInHours >= 1) {
    return `${diffInHours} ${formatSpan("hour", diffInHours)} ago`;
  }

  const diffInMinutes = differenceInMinutes(now, dateToCompare);
  if (diffInMinutes >= 1) {
    return `${diffInMinutes} ${formatSpan("minute", diffInMinutes)} ago`;
  }

  const diffInSeconds = differenceInSeconds(now, dateToCompare);
  if (diffInSeconds >= 15) {
    return `${diffInSeconds} ${formatSpan("second", diffInSeconds)} ago`;
  }

  return "Just now";
};
